import pick from 'lodash/pick'

/* Inspired by https://github.com/michaelcontento/redux-storage-engine-localstorage with modifications */

export function createStorageMiddleware(engine, actions, paths) {
    return ({ getState }) =>
        next =>
        action => {
            const result = next(action)

            if (actions.indexOf(action.type) !== -1) {
                engine.save(pick(getState(), paths))
            }

            return result
        }
}

export class LocalStorageEngine {
    constructor(
        key,
        storage = typeof window.localStorage !== 'undefined' &&
            window.localStorage,
    ) {
        this._key = key
        this._storage = storage
    }

    load() {
        let state = {}

        if (!this._storage) {
            return state
        }

        const jsonState = this._storage.getItem(this._key)

        if (jsonState) {
            try {
                state = JSON.parse(jsonState)
            } catch (err) {
                /* noop */
            }
        }
        return state
    }

    save(state) {
        if (this._storage) {
            try {
                this._storage.setItem(this._key, JSON.stringify(state))
            } catch (err) {
                this._storage.clear()
            }
        }
    }
}
